import DualListView from "../components/DualListView"

class AdDesignJobsClientLibrary {
  constructor(params) {
    this.params = params
    this.role = params.role || null
  }

  index() {
    new DualListView({ roleType: this.role, initial: "module" });
  } 

  show() {
    this.bindAiReuseBtn()
  }

  bindAiReuseBtn() {
    if (!$('.js-no-ai-file').length) { return false }

    N2.handle('click', '.js-no-ai-file', (e) => {
      new N2Styles.toast("No .ai file exists for provided ads.")
    })
  }
}

export default AdDesignJobsClientLibrary
